import { Link as BaseLink } from '@exam-center/router';
import { ArrowBackRoundedIcon, Button, type ButtonProps } from '@shared/components';
import type { ComponentProps } from 'react';

type BaseLinkProps = ComponentProps<typeof BaseLink>;

export interface NavigateBackLinkProps extends Pick<BaseLinkProps, 'to' | 'params' | 'replace'> {
  label?: string;
  sx?: ButtonProps['sx'];
}

export default function NavigateBackLink(props: Readonly<NavigateBackLinkProps>) {
  const { label = 'Back', to, sx, params, replace } = props;

  return (
    // @ts-expect-error MUI's loading button does not support `component` prop
    <Button
      variant='text'
      startIcon={<ArrowBackRoundedIcon />}
      component={BaseLink}
      to={to}
      params={params}
      replace={replace}
      sx={{
        p: (theme) => theme.spacing(0),
        minWidth: 'auto',
        height: 'auto',
        color: (theme) => theme.palette.text.secondary,
        ...sx,
      }}
    >
      {label}
    </Button>
  );
}
